module.exports = __webpack_public_path__ + "static/media/zurich_logo.d625d214.jpg";